<script lang="ts">
  import { EventTracking } from "@shared/services/event_tracking/events";
  import Icon from "@shared/svelte/Components/Icon.svelte";
  import UIRouterLink from "@shared/svelte/Components/UIRouterLink.svelte";

  export let listId: number;

  const { trackClick } = EventTracking;

</script>

<div
  class="fizz-full-width fizz-radius-medium fizz-flex-row fizz-inset-stretch-24 fizz-stack-16 fizz-surface fizz-relative"
>
  <Icon type={"BottleCase"} width={47} height={40} />
  <div class="fizz-full-width fizz-flex-row-responsive">
    <div class="fizz-flex-item">
      <h4 class="fizz-heading-4">Looking to reorder products?</h4>
      <span class="fizz-text-normal fizz-subdued">
        View and reorder all of your previously ordered products from Lists.
      </span>
    </div>
    <UIRouterLink
      stateName="layout.list_details"
      params={{ listId, sort: "last_ordered_at", direction: "DESC" }}
      classes={"fizz-text-inherit fizz-underline-none"}
    >
      <button
        class="fizz-button fizz-stack-4 fizz-flex-item"
        on:click={() => trackClick("list_go_to_lists_from_order_history_banner")}
      >
        Go to List
      </button>
    </UIRouterLink>
  </div>
</div>
